import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { audiences } from '../data/content';

export const Audiences = () => (
  <section data-testid="audiences-section" className="bg-paper">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <SectionHeading
        chapter="04"
        eyebrow="Who We Serve"
        title="Built for Businesses With Bigger Ambitions."
        copy="From startups to schools, nonprofits to personal brands — if growth is the goal, TheBigHub is built for you."
      />
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {audiences.map((a, i) => {
          const Icon = a.icon;
          const wide = i === 0;
          return (
            <Reveal key={a.title} delay={(i % 3) * 0.08} className={wide ? 'sm:col-span-2 lg:col-span-1' : ''}>
              <div
                data-testid={`audience-card-${i + 1}`}
                className="card-lift group h-full rounded-2xl border-2 border-forest bg-forest p-7"
              >
                <div className="mb-5 flex items-center gap-4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/15 text-goldlight transition-colors duration-500 group-hover:bg-white group-hover:text-forest">
                    <Icon size={20} strokeWidth={1.8} />
                  </span>
                  <span className="font-mono text-xs text-white">0{i + 1}</span>
                </div>
                <h3 className="font-display text-lg font-bold leading-snug text-white">{a.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white">{a.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
